import { ReactElement } from 'react';

import styled from '@emotion/styled';

import type { MainSectionType } from '../../../../interfaces/MainSection.interface';
import SectionHeaderSkeleton from './SectionHeaderSkeleton';
import ProductListSkeleton from './ProductListSkeleton';
import MainLineBannerSkeleton from './MainLineBannerSkeleton';
import MainBannerCarouselSkeleton from './MainBannerCarouselSkeleton';
import SpecialDealsSkeleton from './SpecialDealsSkeleton';
import MdOptionListSkeleton from './MdOptionListSkeleton';
import MainRecipesSkeleton from './MainRecipesSkeleton';
import CollectionListCircleSkeleton from './CollectionListCircleSkeleton';
import RandomCollectionArticleSkeleton from './RandomCollectionArticleSkeleton';
import COLOR from '../../../../../shared/constant/colorset';

const SkeletonMainBanner = styled.div`
  height: 90.6667vw;
  background-color: ${COLOR.kurlyGray200};
`;

function NormalSkeleton() {
  return (
    <>
      <SectionHeaderSkeleton />
      <ProductListSkeleton />
    </>
  );
}

function TodayRecommendProducts() {
  return (
    <>
      <SectionHeaderSkeleton isMore={false} isSubTitle={false} />
      <ProductListSkeleton />
    </>
  );
}

function MdChoicesSkeleton() {
  return (
    <>
      <SectionHeaderSkeleton isMore={false} isSubTitle={false} />
      <MdOptionListSkeleton />
    </>
  );
}

function Empty() {
  return <></>;
}

const mainSkeletons: Record<MainSectionType, ReactElement> = {
  CLOSING_SALE: <NormalSkeleton />,
  MD_CHOICES: <MdChoicesSkeleton />,
  TODAY_RECOMMEND_PRODUCTS: <TodayRecommendProducts />,
  RANDOM_COLLECTION: <NormalSkeleton />,
  MAIN_BANNERS: <SkeletonMainBanner />,
  MAIN_BANNER_CAROUSEL: <MainBannerCarouselSkeleton />,
  LINE_BANNERS: <MainLineBannerSkeleton />,
  SPECIAL_DEALS: <SpecialDealsSkeleton />,
  RECIPES: <MainRecipesSkeleton />,
  GROUP_COLLECTION_CIRCLE: <CollectionListCircleSkeleton />,
  RANDOM_COLLECTION_ARTICLE: <RandomCollectionArticleSkeleton />,
  BAND_BANNER: <Empty />,
  LIST_PRODUCT: <Empty />,
  REVIEW_PRODUCTS: <Empty />,
  KURLY_ONLY: <Empty />,
  KURLY_TREND_RANKING: <Empty />,
  CATEGORY_RANKING: <Empty />,
  TIME_RANKING: <Empty />,
  INSTAGRAM_REVIEW: <Empty />,
  MAB_COLLECTION: <Empty />,
};

export function createMainSkeleton(type: MainSectionType) {
  return mainSkeletons[type] || <Empty />;
}
